<router-outlet *ngIf="!showEmptyState" class="hidden-router"></router-outlet>

<div
	*ngIf="showEmptyState"
	class="flex flex-col flex-1 justify-center items-center"
>
	<div class="empty-state-image">
		<img
			src="assets/images/empty-states/mortgages.svg"
			style="max-width: 500px"
		/>
	</div>
	<h3 class="mt-10">Title search</h3>
	<p class="mt-3">Start title search in your file</p>
	<div class="mt-5">
		<app-button
			[icon]="ICON.ADD"
			size="small"
			(click)="startSearch()"
			[testHook]="testHooks.StartTitleSearchButton"
			>Start title search</app-button
		>
	</div>
</div>
